import React from 'react';

import {
    SItem,
    SItemNumber,
    SItemContent,
    SItemTitle,
    SItemText,
} from './styles';

const OrderedItem = ({ itemData }) => {
    const { id, title, text } = itemData;

    return (
        <SItem>
            <SItemNumber>
                { id }
            </SItemNumber>
            <SItemContent>
                <SItemTitle>
                    { title }
                </SItemTitle>
                <SItemText>
                    { text }
                </SItemText>
            </SItemContent>
        </SItem>
    );
};

export default OrderedItem;
